import { render, staticRenderFns } from "./LayoutAside.vue?vue&type=template&id=7a66aeae&scoped=true&"
import script from "./LayoutAside.vue?vue&type=script&lang=js&"
export * from "./LayoutAside.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAside.vue?vue&type=style&index=0&id=7a66aeae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a66aeae",
  null
  
)

export default component.exports